// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","actionArea":"_1ElFFZLV1jg-eZD84e6jTj"};